import React, { Component } from 'react';
import AlbumArt from './AlbumArt';
import NowPlaying from './NowPlaying';
import Controls from './Controls';

class Main extends Component {

  render() {
    return (
      <div className="Player">
        <AlbumArt album={ this.props.track.album } isNowPlaying={ true } />
        <div className="PlayerControls">
          <NowPlaying {...this.props} />
          <Controls />
        </div>
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/Main.js